import React, { useState } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { updateMessages } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import Checkbox from 'apps/auth/components/form/Checkbox';
import Form from 'apps/auth/components/form-multi/Form';
import { PLUS_SUBSCRIBE_FORM_NAME } from 'apps/auth/constants/formName';
import { URL_IMAGES_PAYSEND_PLUS } from 'apps/auth/constants/UrlConstants';
import { useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const Logo = styled.img`
    max-width: 100%;
`;

const Checkmark = styled.div`
    line-height: 1;
    margin-right: 18px;
`;

const PaysendPlusEmployeePrecheckPopup = (props) => {
    const [isChecked, setIsChecked] = useState(false);
    const { plusPrecheckTitle, month, paymentMethod, plusPrecheckTerms, plusPrecheckButton, plusPrecheckPaysendEmployee } = usePageMessages();
    const { fields } = useForm(PLUS_SUBSCRIBE_FORM_NAME);
    const isDisabled = !isChecked;

    const onSubmitHandler = (fields, json) => {
        props.popupRef.current?.close();
        if (json && json.messageBodyMessages) {
            props.updateMessages(json.messageBodyMessages);
        }
        if (json && json.redirectTo) {
            window.location.replace(json.redirectTo);
        }
    };

    const checkHandler = () => {
        setIsChecked(!isChecked);
    };

    const getPaymentMethodName = () => {
        return plusPrecheckPaysendEmployee;
    };

    return (
        <Form
            id="subscription_form"
            action={props.action}
            formName={PLUS_SUBSCRIBE_FORM_NAME}
            validation={false}
            fields={fields}
            validateForm={false}
            getCanonicalPath={false}
            onSubmitHandler={onSubmitHandler}
        >
            <ComplexPopup
                primaryButtonType={'submit'}
                primaryButtonText={plusPrecheckButton}
                primaryButtonDisabled={isDisabled}
                primaryButtonForm={PLUS_SUBSCRIBE_FORM_NAME}
                popupRef={props.popupRef}
                onPrimaryButtonClick={() => {
                    props.submitRef.current?.click();
                    props.popupRef.current?.close();
                }}
            >
                <Row indent="adaptive-32-48" textAlign={'center'}>
                    <Logo src={`${URL_IMAGES_PAYSEND_PLUS}/paysend-plus-logo.svg`} alt="plus-logo" />
                </Row>

                <Text color={'primary'} size={'main'} variant={'paragraph'} textAlign={'center'}>
                    {plusPrecheckTitle}
                </Text>

                <Text size={'header'} textAlign={'center'} variant={'div'} indent={'adaptive-24-32'}>
                    {`0 ${props.subscriptionCurrencyCode} / ${month}`}
                </Text>

                <Row indent={'adaptive-24-32'}>
                    <TableRow title={paymentMethod} pseudoTable>
                        {getPaymentMethodName()}
                    </TableRow>
                </Row>

                <Row flex align={'center'}>
                    <Checkmark>
                        <Checkbox onChange={checkHandler} noValidation />
                    </Checkmark>
                    <Text color={'secondary'} size={'secondary'} variant={'div'}>
                        <DangerouslyHtml dangerouslyHtml={plusPrecheckTerms} />
                    </Text>
                </Row>
            </ComplexPopup>
            <Button type="submit" variant={'hidden'} ref={props.submitRef} />
        </Form>
    );
};

export default connect(null, { updateMessages })(PaysendPlusEmployeePrecheckPopup);
